function changeFontSize(fontSize) {
    return {
        type: 'CHANGE_FONT_SIZE',
        payload: fontSize
    }
}

export default changeFontSize;